export default "https://cdn-static.gokick.com/assets/0ba7a9ad4dd7229a35aca69ca4183ecb31843a51/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";